import { sortTypeEnum } from '@/constants/global';
import { IShareInfoListMutations, } from './types';
const mutations = {
    [IShareInfoListMutations.SET_FILTER_OPTION]({ filterOption }, options) {
        Object.entries(options).forEach(([key, value,]) => {
            // Vue.set(filterOption, key, value);
            filterOption[key] = value;
        });
    },
    [IShareInfoListMutations.SET_SHARE_INFO_SORT_OPTIONS]: (state, payload) => {
        state.shareInfoSortOptions = payload.length > 0 ? payload : [
            {
                // 정렬 대상
                field: 'hubName',
                // 정렬 기준
                value: sortTypeEnum.ASC,
            },
        ];
    },
    [IShareInfoListMutations.GET_SHARE_INFO](state, info) {
        state.shareInfo = info;
    },
    [IShareInfoListMutations.GET_SHARE_STORE_LIST](state, list) {
        state.shareStoreList = list;
    },
    [IShareInfoListMutations.RESET_SHARE_INFO](state) {
        state.shareInfo = null;
    },
    [IShareInfoListMutations.RESET_SHARE_STORE_LIST](state) {
        state.shareStoreList = [];
    },
    [IShareInfoListMutations.SET_SELECTED_ROW_SHARE_INFO](state, hubInfo) {
        state.selectedRowShareInfo = hubInfo;
    },
};
export default mutations;
